export default __webpack_public_path__ + "static/media/facebookIcon.de9712b7.svg";